// extracted by mini-css-extract-plugin
export default {"bold":"RecordDisplay_bold__WnUh9","playerCount":"RecordDisplay_playerCount__6O3OZ"};